import { render } from "./PageTitleComponent.vue?vue&type=template&id=2f1fa2e6"
import script from "./PageTitleComponent.vue?vue&type=script&lang=js"
export * from "./PageTitleComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__